import { slotCannon } from "./index";
import { slotCannonBootDefaults } from "./boot/bootDefaults";
import { launchGame } from "@slot/game-shell";

void launchGame(slotCannon, import.meta.env, slotCannonBootDefaults);
